export interface FieldValidationError {
    errorMessage: string
}
export interface FieldValidationResult {
    key: string,
    errors: FieldValidationError[]
}
export default class ValidationResult<T> {
    StatusCode?: number;

    StatusText?: string;

    Resource?: T;

    FieldResults?: FieldValidationResult[];

    ConcatErrorMessage?: string;

    public static fromMvcAsync = async <TModel>(response: Response, expectResponseBody: boolean) => {
        const result = new ValidationResult<TModel>();
        result.StatusCode = response.status;
        if (result.StatusCode === 200 && expectResponseBody) {
            const parsed = await response.json();
            result.Resource = parsed as TModel;
        }

        if (result.StatusCode === 400) {
            const parsed = await response.json();
            result.FieldResults = parsed.fields as FieldValidationResult[];
        }

        if (result.StatusCode.toString().startsWith('5')) {
            throw new Error(`Internal server error: ${response.body}`);
        }

        return result;
    };

    public static fromWebApiAsync = async <TModel>(response: Response, expectResponseBody: boolean) => {
        const result = new ValidationResult<TModel>();
        result.StatusCode = response.status;
        if (result.StatusCode === 200 && expectResponseBody) {
            const parsed = await response.json();
            result.Resource = parsed as TModel;
        }

        if (result.StatusCode === 400) {
            const parsed = await response.json();
            return ValidationResult.fromValidationErrors<TModel>(parsed);
        }

        if (result.StatusCode.toString().startsWith('5')) {
            throw new Error(`Internal server error: ${response.body}`);
        }

        return result;
    };

    public static fromValidationErrors = <TModel>(errorModel: { message: string, modelState: { [key: string]: string[] } }) => {
        const result = new ValidationResult<TModel>();
        result.StatusCode = 400;
        result.StatusText = 'Validation error';
        const results = Object.keys(errorModel.modelState).map(k => ({
            key: k,
            errors: errorModel.modelState[k].map((m: string) => ({ errorMessage: m }))
        }));
        result.FieldResults = results;
        result.ConcatErrorMessage = results
            ?.flatMap(field => field.errors)
            .map(err => err.errorMessage)
            .join('\r\n');
        return result;
    };

    hasErrors = () => this.FieldResults !== undefined && this.FieldResults.filter(r => r.errors.length > 0).length > 0;

    wasSuccessful = () => this.StatusCode === 200;
}
